<template>
<div></div>
</template>
 
<script>
import { getHomeInfo,getHomeIndex } from '@/api/index'

export default {
  data () {
    return {
      data: {},
      data7:{},
      data30:{},
      indexs:['Venue'],
      actindex:'Venue'
    }
  },
  mounted () {
    getHomeIndex().then(response => {
      for(let i = 0;i<response.data.length;i++){
        if(this.indexs.indexOf(response.data[i])==-1){
          this.indexs.push(response.data[i])
        }
      }
        // this.data = response.data.data
    }).catch(res => {
        
    })
    getHomeInfo(-1,this.actindex).then(response => {
        this.data = response.data
    }).catch(res => {
        
    })
    getHomeInfo(-7,this.actindex).then(response => {
        this.data7 = response.data
    }).catch(res => {
        
    })
    getHomeInfo(-30,this.actindex).then(response => {
        this.data30 = response.data
    }).catch(res => {
        
    })
  },
  methods: {
    toThousands(num) {
        var result = '', counter = 0;
        num = (num || 0).toString();
        for (var i = num.length - 1; i >= 0; i--) {
        counter++;
        result = num.charAt(i) + result;
        if (!(counter % 3) && i != 0) { result = ',' + result; }
        }
        return result;
    },
    headitemclick(index){
      this.actindex = index;
      getHomeInfo(-1,this.actindex).then(response => {
          this.data = response.data
      }).catch(res => {
          
      })
      getHomeInfo(-7,this.actindex).then(response => {
          this.data7 = response.data
      }).catch(res => {
          
      })
      getHomeInfo(-30,this.actindex).then(response => {
          this.data30 = response.data
      }).catch(res => {
          
      })
    }
  }
}
</script>

<style lang='less' scoped>
.fb-wrap{
    box-sizing: border-box;
    width: 100%;
    margin: 50px auto;
    padding: 50px 50px 0;
    position: relative;
}
.fb-body{
  width: 100%;
  display: flex;
  border: 1px solid #eeeeee;
  border-radius: 20px;
  position: relative;
  z-index: 10;
  background-color: #fff;
}
.fb-item{
    flex: 1;
    text-align: center;
}
.fb-item h2{
    margin: 10px 0 38px;
    font-size: 36px;
    font-weight: 600;
}
.fb-item span{
    display: inline-block;
    font-size: 18px;
    width: 100%;
    margin: 10px auto;
}
.fb-item .fb-num{
    font-size: 36px;
    margin-bottom: 28px;
    font-family: Gill Sans;
}
.fb-item-first{
  margin-top: 38px;
}
.fb-head{
  position: absolute;
  top: 1px;
  left: 70px;
  overflow: hidden;
  width: 100%;
}
.fb-head-sec{
  text-align: center;
  display: inline-block;
  float: left;
  width: 100px;
  height: 50px;
  line-height: 50px;
  border:1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
.fb-head-sec-act{
  border:1px solid deepskyblue;
  color: deepskyblue;
}
</style>




// WEBPACK FOOTER //
// src/components/total/index.vue